import HTTP from '../HTTPEdition';

const URL_BASE = 'Mail';

async function emailAsync(params, data) {
  const response = await HTTP.post(`${URL_BASE}/EmailAsync`, data,
    {
      params: {
        mettreEdition: params.mettreEdition,
        societeId: params.societeId,
        typeDonnee: params.typeDonnee,
        elementId: params.elementId,
      },
    });
  return response;
}

export default emailAsync;

export async function emailWithManyEditionAsync(params, data) {
  const response = await HTTP.post(`${URL_BASE}/EmailWithManyEditionAsync`, data,
    {
      params: {
        societeId: params.societeId,
        typeDonnee: params.typeDonnee,
        elementId: params.elementId,
      },
    });
  return response;
}

export async function reseauFaceImpactEmailAsync(params, data) {
  const response = await HTTP.post(`${URL_BASE}/ReseauFaceImpactEmailAsync`, data, { params });
  return response;
}
